import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import {
  addPaymentGatewayConfig,
  getPaymentGatewayConfigName,
  updatePaymentGatewayConfig,
} from "../../../services/PaymentGatewayConfig/PaymentGatewayConfig";
import { Dropdown } from "primereact/dropdown";
import AdminMenu from "../../AdminMenu";

const PaymentGatewayConfigCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);
  const [gatewayNameData, setGatewayNameData] = useState([]);

  const paymentGatewayStatus = [{
    name: "ACTIVE",
    value: "ACTIVE",
  }, {
    name: "INACTIVE",
    value: "INACTIVE",
  }]

  const currencyData = [{
    name: "356",
    value: "356",
  },{
    name: "INR",
    value: "INR",
  }]

  const [input, setInput] = useState({
    gatewayName: "",
    currency: "INR",
    clientKeyId: "",
    clientKeySecret: "",
    baseUrl: "",
    aggregatorId:"",
    merchantId:"",
    returnURL:"",
    responseOnEmailId:"",
    initiatePaymentLinkURL:"",

  });

  const [paymentGatewayStatusValue, setPaymentGatewayStatusValue] = useState("ACTIVE") 

  useEffect(() => {
    setInput((prevState) => ({
      ...prevState,
      gatewayName: item?.gatewayName || "",
      // currency: "INR",
      currency: item?.currency || '',
      clientKeyId: item?.clientKeyId || "",
      clientKeySecret: item?.clientKeySecret || "",
      baseUrl: item?.baseUrl || "",
      aggregatorId: item?.aggregatorId || "",
      merchantId: item?.merchantId || "",
      returnURL: item?.returnURL || "",
      responseOnEmailId: item?.responseOnEmailId || "",
      initiatePaymentLinkURL: item?.initiatePaymentLinkURL || "",
    }));

    setPaymentGatewayStatusValue(item?.status || "ACTIVE");
  }, [item]);

  const fetchPaymentGatewayConfig = () => {
    getPaymentGatewayConfigName()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const ModifiedRes = Res.map((item) => ({
            name: item,
            value: item,
          }));
          setGatewayNameData(ModifiedRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchPaymentGatewayConfig();
  }, []);

  const [gatewayNameError, setGatewayNameError] = useState("");
  const [currencyError, setCurrencyError] = useState("");
  const [clientKeyIdError, setClientKeyIdError] = useState("");
  const [clientKeySecretError, setClientKeySecretError] = useState("");

  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const handleGatewayNameChange = (selectedItem) => {
    setInput({
      ...input,
      gatewayName: selectedItem,
    });
  };

  const handleGatewayStatusChange = (selectedItem) => {
    setPaymentGatewayStatusValue(selectedItem);
  };

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setGatewayNameError("");
    setCurrencyError("");
    setClientKeyIdError("");
    setClientKeySecretError("");

    let isValid = true;
    if (!input.gatewayName) {
      setGatewayNameError("Gateway Name is Required");
      isValid = false;
    }
    // if (!input.currency) {
    //   setCurrencyError("Currency is Required");
    //   isValid = false;
    // }
    // if (!input.clientKeyId) {
    //   setClientKeyIdError("Client Key Id is Required");
    //   isValid = false;
    // }

    // if (!input.clientKeySecret) {
    //   setClientKeySecretError("Client Key Secret is Required");
    //   isValid = false;
    // }

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          ...input,
          brandId: brandId,
        };

        const UpdateData = {
          ...input,
          brandId: brandId,
          id: item?.id,
          status: paymentGatewayStatusValue
        };

        // Call the service function for creating pickup request

        if (!isUpdating) {
          addPaymentGatewayConfig(data, brandId)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/PaymentGatewayConfigView");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          updatePaymentGatewayConfig(UpdateData, brandId)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/PaymentGatewayConfigView");
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/PaymentGatewayConfigView")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Payment Gateway {item?.id ? 'Edit' : 'Create'}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className=" mt-3 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="gatewayName"
              value={input.gatewayName}
              onChange={(e) =>
                handleGatewayNameChange(e.target.value)
              }
              options={gatewayNameData}
              optionLabel="name"
              placeholder="Payment Gateway Name"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {gatewayNameError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {gatewayNameError}
              </p>
            )}
            <label
              htmlFor="gatewayName"
              className="text-md"
              style={{ color: "blue" }}
            >
              Gateway Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-3 flex-1">
          <FloatLabel>
           {/* <InputText
              id="currency"
              value={input.currency}
              onChange={(e) => {
                setInput({
                  ...input,
                  currency: e.target.value,
                });
                setCurrencyError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              // disabled={true}
            />*/}
            <Dropdown
              id="currency"
              value={input.currency}
              onChange={(e) =>
                setInput({
                  ...input,
                  currency: e.target.value,
                })
              }
              options={currencyData}
              optionLabel="name"
              placeholder="Please Select Currency"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {/*currencyError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {currencyError}
              </p>
            )*/}

            <label
              htmlFor="currency"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Currency <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-3  flex-1">
          <FloatLabel>
            <InputText
              id="clientKeyId"
              value={input.clientKeyId}
              onChange={(e) => {
                setInput({
                  ...input,
                  clientKeyId: e.target.value,
                });

                setClientKeyIdError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {/*clientKeyIdError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {clientKeyIdError}
              </p>
            )*/}

            <label
              htmlFor="clientKeyId"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Client Key Id <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-3  flex-1">
          <FloatLabel>
            <InputText
              id="clientKeySecret"
              value={input.clientKeySecret}
              onChange={(e) => {
                setInput({
                  ...input,
                  clientKeySecret: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {/*clientKeySecretError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {clientKeySecretError}
              </p>
            )*/}

            <label
              htmlFor="clientKeySecret"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Client Key Secret
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-3 flex-1">
          <FloatLabel>
            <InputText
              id="baseUrl"
              value={input.baseUrl}
              onChange={(e) =>
                setInput({
                  ...input,
                  baseUrl: e.target.value,
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="baseUrl"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Base Url
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-3  flex-1">
          <FloatLabel>
            <InputText
              id="aggregatorId"
              value={input.aggregatorId}
              onChange={(e) => {
                setInput({
                  ...input,
                  aggregatorId: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
             

            <label
              htmlFor="aggregatorId"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Aggregator Id
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-3 flex-1">
          <FloatLabel>
            <InputText
              id="returnURL"
              value={input.returnURL}
              onChange={(e) =>
                setInput({
                  ...input,
                  returnURL: e.target.value,
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="returnURL"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Return Url
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-3  flex-1">
          <FloatLabel>
            <InputText
              id="responseOnEmailId"
              value={input.responseOnEmailId}
              onChange={(e) => {
                setInput({
                  ...input,
                  responseOnEmailId: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />


            <label
              htmlFor="responseOnEmailId"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Response On Email Id
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-3 flex-1">
          <FloatLabel>
            <InputText
              id="initiatePaymentLinkURL"
              value={input.initiatePaymentLinkURL}
              onChange={(e) =>
                setInput({
                  ...input,
                  initiatePaymentLinkURL: e.target.value,
                })
              }
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />

            <label
              htmlFor="initiatePaymentLinkURL"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Initiate Payment Link Url
            </label>
          </FloatLabel>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-3  flex-1">
          <FloatLabel>
            <InputText
              id="merchantId"
              value={input.merchantId}
              onChange={(e) => {
                setInput({
                  ...input,
                  merchantId: e.target.value,
                });
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
             
            <label
              htmlFor="merchantId"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Merchant Id
            </label>
          </FloatLabel>
        </div>
      </div>

      {item?.id && <div className="flex flex-1 mb-3">
        <div className=" mt-3 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="status"
              value={paymentGatewayStatusValue}
              onChange={(e) =>
                handleGatewayStatusChange(e.target.value)
              }
              options={paymentGatewayStatus}
              optionLabel="name"
              placeholder="Status"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />

            <label
              htmlFor="gatewayName"
              className="text-md"
              style={{ color: "blue" }}
            >
              Status <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>}

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PaymentGatewayConfigCreate;
